import { bus } from '@/utils/bus';
import SucBaseModal from './sucBaseModal';
import ErrBaseModal from './errBaseModal';

// 顶部消息提示
const SuccessBase = (mes) => new SucBaseModal(true, mes, 2000).showMsg();
const ErrBase = (mes) => new ErrBaseModal(true, mes, 2000).showMsg();
// 右侧消息提示
const SuccessNotify = (mes) => new SucBaseModal(true, mes, 2000).showNotifyMsg();
const ErrNotify = (mes) => new ErrBaseModal(true, mes, 2000).showNotifyMsg();
const ApiRequest = (req) => {
  if (req.status !== '0') {
    ErrBase(`${req.message}，错误码：${req.status}`);
    if (req.message === '用户未登录') {
      bus.$emit('goto', '/login');
      return false;
    }
    return false;
  }
  return true;
};
export {
  ApiRequest, SuccessBase, ErrBase, SuccessNotify, ErrNotify,
};
